import { TNavigationActions } from './navigation.action';
import { NavigationInfoActionType, TNavigationState } from './navigation.models';

export const initialNavigationState: TNavigationState = {
  selectedNavigationItem: null,
  customPageHeader: { title: null },
};

export function navigationReducer(state = initialNavigationState, action: TNavigationActions): TNavigationState {
  switch (action.type) {
    case NavigationInfoActionType.SelectNavigationItem:
      return { ...state, selectedNavigationItem: action.payload };
    case NavigationInfoActionType.SetCustomPageHeader:
      return { ...state, customPageHeader: action.payload };
    default:
      return state;
  }
}
